import { get, isEmpty } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useQuery } from 'react-apollo';
import getGqlOperationName from '../../../utils/getGqlOperationName';
import SpinnerError from '../../utils/SpinnerError';
import CommonTreeSelectorBase from '../CommonTreeSelector';
import useApplyFilter from './hooks/useApplyFilter';
function GqlStaticTreeSelector({ title, gql, tree = 'GqlStaticTreeSelector', isSingleSelector = false, plugins = {}, adapter = {}, gqlVariables = {}, disabled = false, gqlSkip = false, initialSelectAll, onChange, selectionFilter, cookModels, hasInitSearch = false, models, setAllModels, searchField, hasFilter, hasMarginLeft, gqlFetchPolicy, dataCy, ...props }) {
    const extractModels = useCallback(queryRes => {
        const data = get(queryRes, getGqlOperationName(gql), []);
        return cookModels ? cookModels(data) : data;
    }, [cookModels, gql]);
    const { applyFilters } = useApplyFilter();
    const onCompleted = useCallback(data => {
        setAllModels && setAllModels(extractModels(data));
        const { value } = props;
        if (isEmpty(value) && data && initialSelectAll && onChange) {
            let models = extractModels(data);
            if (selectionFilter) {
                models = selectionFilter(models);
            }
            onChange(models);
            if (hasInitSearch && applyFilters) {
                requestAnimationFrame(() => {
                    applyFilters();
                });
            }
        }
    }, [
        setAllModels,
        props,
        hasInitSearch,
        applyFilters,
        extractModels,
        onChange,
        initialSelectAll,
        selectionFilter,
    ]);
    const { data, error, loading } = useQuery(gql, {
        variables: gqlVariables,
        skip: gqlSkip || !isEmpty(models),
        fetchPolicy: gqlFetchPolicy,
        onCompleted,
    });
    const _models = useMemo(() => models || extractModels(data), [
        data,
        models,
        extractModels,
    ]);
    return (<SpinnerError error={error} inline={false} loading={loading}>
      <CommonTreeSelectorBase {...props} adapter={adapter} dataCy={dataCy} disabled={disabled || loading} hasFilter={hasFilter} hasMarginLeft={hasMarginLeft} isSingleSelector={isSingleSelector} models={_models} plugins={plugins} searchField={searchField} selectionFilter={selectionFilter} title={title} treeName={tree} onChange={onChange}/>
    </SpinnerError>);
}
export default GqlStaticTreeSelector;
